import { render } from "./TermsAndConditionsOfUse.vue?vue&type=template&id=2b5dbbc6"
import script from "./TermsAndConditionsOfUse.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsOfUse.vue?vue&type=script&lang=js"

import "./TermsAndConditionsOfUse.vue?vue&type=style&index=0&id=2b5dbbc6&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__